import { render, staticRenderFns } from "./BCXTextArea.vue?vue&type=template&id=1e5dda99&scoped=true"
import script from "./BCXTextArea.vue?vue&type=script&lang=ts"
export * from "./BCXTextArea.vue?vue&type=script&lang=ts"
import style0 from "./BCXTextArea.vue?vue&type=style&index=0&id=1e5dda99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5dda99",
  null
  
)

export default component.exports